import SettingsBox from "./SettingsBox";

export default SettingsBox;
